export default function showVideo() {
    document.querySelectorAll('.video .video-container').forEach($videoContainer => {

        const video = $videoContainer.querySelector('iframe');
        const dataSrc = video.getAttribute('data-src');
        video.removeAttribute('data-src');

        if ($videoContainer.querySelectorAll('.video-icon').length > 0) {
            $videoContainer.querySelectorAll('.video-icon').forEach($link => {

                $link.addEventListener('click', event => {
                    event.preventDefault();
                    if (video && dataSrc) {
                        setTimeout(() => {
                            $videoContainer.classList.add('video-visible');
                            video.setAttribute('src', dataSrc);
                            if (dataSrc.includes('autoplay')) {
                                video.setAttribute('autoplay', "autoplay");
                            }
                        }, 100);
                    }
                });
            })
        } else {
            if (video && dataSrc) {
                setTimeout(() => {
                    $videoContainer.classList.add('video-visible');
                    video.setAttribute('src', dataSrc);
                    if (dataSrc.includes('autoplay')) {
                        video.setAttribute('autoplay', "autoplay");
                    }
                }, 100);
            }
        }


    });
}
